class FreeTextQuestionStrategy {
    constructor(playScreenController, result) {

        this.playScreenController = playScreenController;
        this.result = result;
        this.mediaContainer = null;
        this.questionContainer = null;

        $(document).off("click", '#validateFreeTextBtn', this.onValidateBtnClick.bind(this));
        $(document).one("click", '#validateFreeTextBtn', this.onValidateBtnClick.bind(this));
    };

    draw() {
        this.mediaContainer = $('#mediaContainer');
        this.questionContainer = $('#questionContainer');
        this.mediaContainer.slideDown();
        this.mediaContainer.css('text-align', 'center');

        this.preloader = this.playScreenController.createPreloader(customIcons["QUESTION_MULTIMEDIA_TEXT"]).appendTo(this.mediaContainer);

        this.questionContainer.css('background-color', '#fff');
        this.questionContainer.css('min-height', 'calc(100% - 185px)');
        const mainContainer = $('#mainContainer');
        mainContainer.css('overflow', 'auto');
        this.questionContainer = null;
        this.preload();
        $('body').addClass('stop-scrolling');

        if(!$('#simplifyWildcardLink').hasClass('disabled-link')) {
            $('#simplifyWildcardLink').find('img').attr('src', '/images/simplificar.png');
            $('#simplifyWildcardLink').addClass('disabled-link locked-simplify');
            $('#simplifyWildcardSection').find('p').removeClass('black-text');

            $('#simplifyWildcardLink').unbind("click");
        }

        let bottomHeight = $('#playBottom').outerHeight();
        $('.free-text').css('padding-bottom', bottomHeight);
    };

    preload() {
        $(".question-color-wrapper").css("background-color", hex2rgba(this.playScreenController.currentQuestion.category.color, 0.75));
        $(".question-color-wrapper").show();
        this._preloadTimeout = setTimeout(this.startTime.bind(this), 1000);
    };

    startTime() {
        this.hideImage();
        $(".question-color-wrapper").hide();
        this.playScreenController.startTimer(this.result);
    };

    hideImage() {
        if(this.preloader) {
            this.preloader.hide();
        }
        this.mediaContainer.slideUp();
        $('body').removeClass('stop-scrolling');
    };

    onValidateBtnClick() {
        var response = $(freeTextAnswerInput).val().trim();

        if (response.length != 0) {

            if (response.toLowerCase() == this.playScreenController.currentQuestion.correct_answer.toLowerCase().trim()) {
                $('#freeTextCorrect').trigger('click',false);
                if(world.world_mode !== 'ASSESSMENT' && !this.playScreenController.result.has_test) {
                    $('.free-text-input-container-inside').addClass('box-shadow-green');
                }
            } else {
                $('#freeTextIncorrect').trigger('click',false);
                if(world.world_mode !== 'ASSESSMENT' && !this.playScreenController.result.has_test) {
                    $('.free-text-input-container-inside').addClass('box-shadow-red');
                }
                if (world.question_show_answer) {
                    $('#freeTextSolution').text(this.playScreenController.currentQuestion.correct_answer).show();
                }
            }

        } else {
            $(document).one("click", '#validateFreeTextBtn', this.onValidateBtnClick.bind(this));
        }

        return false;
    }

    cancel() {
        clearTimeout(this._preloadTimeout);
    }

    onResolveWildcard() {
        $('#freeTextAnswerInput').val(this.playScreenController.currentQuestion.correct_answer.toLowerCase().trim());
        $('.free-text-input-container-inside').addClass('box-shadow-green');
    }

}